import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IGrantPermissionPanelStyles {
  root?: IStyle;
}

export interface IGrantPermissionPanelClassNames {
  root: string;
}

export const grantPermissionPanelStylesDefault = (_theme: IH2OTheme): Partial<IGrantPermissionPanelStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});
